import React, { useEffect, useState } from "react";
import Image from "../../components/Images/Image";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import Input from "../../components/input";
import { useHistory } from "react-router";
import { getLocalStorage, removeLocalStorageKey, setLocalStorage } from "../../lib/session";
import { showToast, setSessionData } from "../../lib/global";
import { loginApi } from "../../services/auth.service";
import CustomCheckbox from '../../components/checkbox';

const LoginPage = (props) => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [rememberMe, setRememberMe] = useState(Boolean(getLocalStorage('rememberMe')))

    useEffect(()=>{
        if(rememberMe){
            const i_email = getLocalStorage('email');
            const i_password = getLocalStorage('password');
            setEmail(i_email);
            setPassword(i_password)
        }
    },[])

    const handleFormSubmit = (event) => {
        event.preventDefault();
        setLoading(true);
        if(!email || !password) {
            showToast("Email and password fields are requrired!", 'error')
        };

       

        // call your api here
        const payload = {email, password}
        loginApi(payload).then(res=>{
            if(res && res.data && res.data.data){
                const result = res.data.data;
                setLocalStorage('token', result.token);
                showToast("You logged in successfully!", 'success')
                setSessionData(result)
                history.push('/');
                if(rememberMe){
                    setLocalStorage('rememberMe', true);
                    setLocalStorage('email', email);
                    setLocalStorage('password', password);
                }else{
                    removeLocalStorageKey('rememberMe')
                    removeLocalStorageKey('email')
                    removeLocalStorageKey('password')
                }
            }
        }).catch(error=>{
            console.error(error)
            setLoading(false)
            showToast(error?.response?.data?.message || "Falied to login!", 'error')
        })

        // showToast("You logged in successfully!", 'success')
        // setLocalStorage('token', "dummy_token")

        // setLocalStorage('email', email);
        // setLocalStorage('password', password);
        // setTimeout(() => {
        //     history.push('/');
        // }, 2000);
    };

    const handleFormInput = (event, key) => {
        const value = event.target.value;
        switch (key) {
            case "email":
                setEmail(value);
                break;
            case "password":
                setPassword(value);
                break;
            default:
                return;
        }
    };

    const handleRememberMe = (event) => {
        const value = event.target.checked || false;
        setRememberMe(value)
    }

    return (
        <React.Fragment>
            <Image
                src="/images/login_background.jpeg"
                className="vh-100 vw-100 cover"
            />
            <div className="container w-100 h-100 d-flex justify-content-center align-items-center">
                <div className="container login_container d-flex align-items-center justify-content-center">
                    <form onSubmit={handleFormSubmit} className="login_form">
                        <h5 className="login_header text-white bold">
                            Login here
                        </h5>
                        <div className="form-group position-relative mb-4">
                            <Input
                                className="form-control pl-4"
                                type="email"
                                name="email"
                                id="email"
                                onChange={(e) => handleFormInput(e, "email")}
                                value={email}
                                placeholder="Email"
                            />
                            <EmailIcon
                                color="error"
                                className="login_helper_icon"
                            />
                        </div>
                        <div className="form-group position-relative mb-4">
                            <Input
                                className="form-control"
                                type="password"
                                name="password"
                                id="password"
                                value={password}
                                onChange={(e) => handleFormInput(e, "password")}
                                placeholder="Password"
                            />
                            <LockIcon
                                color="error"
                                className="login_helper_icon"
                            />
                        </div>
                        <div className="button d-flex">
                            <CustomCheckbox
                                label="Remember Me"
                                checked={rememberMe}
                                onChange={handleRememberMe}
                                formControlClass="ml-1 text-white"
                                className='m-0 p-0 text-white'
                            />
                            <button
                                type="submit"
                                className="btn btn-primary ml-auto"
                            >
                                {loading ? (
                                    "Loading..."
                                ) : (
                                    <>
                                        Submit <ArrowRightAltIcon />
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <style jsx="true">{`
                .container {
                    position: absolute;
                    top: 0;
                    right: 0;
                    left: 0;
                    bottom: 0;
                }
                .login_container {
                    width: 370px;
                    background: #00000096;
                    height: 370px;
                    margin: auto;
                }
                .login_form {
                    width: 80%;
                }
                .login_header {
                    position: absolute;
                    top: 25px;
                    width: 100%;
                    left: 0;
                    right: 0;
                }
                .form-control {
                    padding-left: 32px !important;
                }
                .login_helper_icon {
                    position: absolute;
                    left: 0;
                    top: 0;
                    height: 100%;
                    padding: 3px;
                    margin: 0 4px;
                }
            `}</style>
        </React.Fragment>
    );
};

export default LoginPage;
